import React from "react";
import { Component } from "react";
// import TasksCalendar from "../../../Desk/Eagleviews/tasksCalendar";
// import Monitor from "../../../DeskViews/Monitor";
// import Modal from "../../../../components/Modal";
import Responsive from "../../../../components/Responsive";
// import CalendarWeeklyView from '../../../../components/views/CalendarWeeklyView'
// import FormViewer from "../../../../components/FormViewer";
// import { translate } from "../../../../utils/useful";
// import ButtonAnimated from "../../../../components/buttons/ButtonAnimated";
import Collapsible from "react-collapsible";
import CalendarWeekDaySelector from "../../../../components/views/CalendarWeekDaySelector";
import Calendar from '../../../../components/views/Calendar';
import CalendarSelectScope from "../../../../components/views/CalendarSelectScope";
import { translate } from "../../../../utils/useful";


export default class BookingReservation extends Component {
    state = {

        currentCalendar: new Calendar(),


        header: [
            { key: 'scheduler', type: 'AvailabilityTimeInput', col: '12', information: { label: '{{lang}}Scheduler', address: 'getAvailableTimes', filter: {}, inputClass: 'aa', isSearchable: true, placeholder: '{{lang}}Select', required: false, } },
        ],

        week: [
            { name: 'sun', date: '4', },
            { name: 'Mon', date: '5', },
            { name: 'Tue', date: '6', },
            { name: 'Wed', date: '7', },
            { name: 'Thu', date: '8', },
            { name: 'Fri', date: '9', },
            { name: 'Sat', date: '10', },
        ],

        provider: [
            { image: '/images/p1.png', name: 'Sara Mohseni', des: '3 years of experince in nail polish', role: 'verified', rating: '4/5', time: [{ time: '18:00', price: '200$' }, { time: '18:30', price: '200$' }, { time: '19:00', price: '200$' }, { time: '19:30', price: '200$' },] },
            { image: '/images/p2.png', name: 'Sara Mohseni', des: '3 years of experince in nail polish', role: 'verified', rating: '4/5', time: [{ time: '18:00', price: '200$' }, { time: '18:30', price: '200$' }, { time: '19:00', price: '200$' }, { time: '19:30', price: '200$' },] },
            { image: '/images/p3.png', name: 'Sara Mohseni', des: '3 years of experince in nail polish', role: 'verified', rating: '4/5', time: [{ time: '18:00', price: '200$' }, { time: '18:30', price: '200$' }, { time: '19:00', price: '200$' }, { time: '19:30', price: '200$' },] },
            { image: '/images/p4.png', name: 'Sara Mohseni', des: '3 years of experince in nail polish', role: 'verified', rating: '4/5', time: [{ time: '18:00', price: '200$' }, { time: '18:30', price: '200$' }, { time: '19:00', price: '200$' }, { time: '19:30', price: '200$' },] },
            { image: '/images/p5.png', name: 'Sara Mohseni', des: '3 years of experince in nail polish', role: 'verified', rating: '4/5', time: [{ time: '18:00', price: '200$' }, { time: '18:30', price: '200$' }, { time: '19:00', price: '200$' }, { time: '19:30', price: '200$' },] },
            { image: '/images/p6.png', name: 'Sara Mohseni', des: '3 years of experince in nail polish', role: 'verified', rating: '4/5', time: [{ time: '18:00', price: '200$' }, { time: '18:30', price: '200$' }, { time: '19:00', price: '200$' }, { time: '19:30', price: '200$' },] },
        ],
        isOpen: {},

    }


    componentDidMount() {
        this.state.currentCalendar.init(this)
    }


    handleStep = () => {
        let data = this.form.getForm()
        if (data != null) {
            this.props.setData(data, () => {
                this.props.changePage('booking', 2)
            })
        }
    }

    changeCollapse = (item, index) => {
        let isOpen = this.state.isOpen
        isOpen[index] = !isOpen[index]

        this.setState({ isOpen })
    }



    setTime = (item) => {
        this.props.setData(item)
        this.props.bookingService(item)
        this.props.changePage('form')
    }


    render() {
        return (

            <div className="h-100  w-100  scroll-no-scrollbar pb-5">
                <div className=" ">
                    {/* <div className="flexcb px-4">
                        <p className="font-size-14 main-c6 weight-500">Reservation date</p>
                        <div className="flexc">
                            <button className="flexc px-2 py-1 br-20 mx-3 booking-date-b">
                                <p className="font-size-14 mld-2">May</p>
                                <img width={20} className="mld-2" src="/assets/icons/arrow-bottom-gray.svg" />
                            </button>
                            <button className="flexc px-2 py-1 br-20 booking-date-b">
                                <p className="font-size-14 mld-2">2023</p>
                                <img width={20} className="mld-2" src="/assets/icons/arrow-bottom-gray.svg" />
                            </button>
                        </div>
                    </div> */}



                    <div className="flexc px-4 py-4" style={{ borderBottom: '1px solid #eee', backgroundColor: '#f6f6f6' }}>

                        <div>
                            <img className="br-10" width={100} src={'/images/p1.png'} />
                        </div>

                        <div className="mld-5">
                            <p className="font-size-18  weight-500">Service name</p>
                            <p className="font-size-13">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Non iusto repudiandae, ullam voluptates ducimus, eligendi in quis voluptatibus, ipsum mollitia quam id similique distinctio natus doloribus sed fuga animi consequatur.</p>
                        </div>

                    </div>


                    <div className="flexcb py-1" style={{ borderBottom: '0px solid #eee', backgroundColor: '#fff' }}>

                        <div className='px-2 flex-1' style={{}}>
                            <button onClick={() => this.state.currentCalendar.goToToday()} className='note-hover-box2   flexc my-1 br-20'>
                                <p className='font-size-14 text-semibold br-20 px-2 py-1' style={{ color: this.state.currentCalendar?.activeDay?.key == this.state.currentCalendar?.today?.key ? null : this.props.colors?.primaryColor, border: `1px solid ${(this.state.currentCalendar?.activeDay?.key == this.state.currentCalendar?.today?.key ? '#000' : this.props.colors?.primaryColor)}` }}>{translate("Go To Today")}</p>
                            </button>
                        </div>
                        <div className="flex-2 flexcc">
                            <CalendarSelectScope setCalendar={this.setCalendar} currentCalendar={this.state.currentCalendar} currentCalendarView={'week'} />
                        </div>

                        <div className="flex-1"></div>
                    </div>

                    <div style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                        <CalendarWeekDaySelector currentCalendar={this.state.currentCalendar} colors={this.props.colors} />
                    </div>


                    <div className="pt-3 mt-2 ">
                        <p className="font-size-18 weight-600 px-4">{translate("Select Provider")}</p>
                        <div className="mt-4 ">
                            {this.state.provider.map((prop, index) => {
                                return (
                                    <div className="mb-4 ">
                                        <button className="flexcb px-4 w-100" onClick={() => this.changeCollapse(prop, index)}>
                                            <div className="flexc">
                                                <img className="br-10" width={70} src={prop.image} />
                                                <div className="mld-3 w-100">
                                                    <div className="flexcb w-100">
                                                        <p className="font-size-16 main-c3 weight-500 mld-1">{prop.name}</p>

                                                    </div>
                                                    <div className="mt-1">
                                                        <p className="font-size-13 main-c5 mld-1">{prop.des}</p>
                                                    </div>

                                                    <button className="flexc mt-1">
                                                        <p className="font-size-14" style={{ color: '#007aff' }}>Provider Information</p>
                                                        {/* <img width={20} src="/assets/icons/booking/arrow-right-booking.svg" /> */}
                                                    </button>
                                                    {/* <div className="flexc pt-1">
                                                    <img width={20} className="flexcc" src="/assets/icons/booking/verified.svg" />
                                                    <p className="font-size-12 main-c5">{prop.role}</p>
                                                </div> */}
                                                    {/* <div className="flexc">
                                                    <img width={20} className="flexcc" src="/assets/icons/booking/rate.svg" />
                                                    <p className="font-size-12 main-c5">{prop.rating}</p>
                                                </div> */}
                                                </div>
                                            </div>
                                            <div>
                                                <button className="flexc px-2 py-2 br-20 " style={{ border: '1px solid #000' }}  >
                                                    <p className=" font-size-14 mld-2">{translate("Time slots")}</p>
                                                    <img width={20} className={'mld-2 transition  ' + (this.state.isOpen[index] ? 'rotate-90' : '')} src="/assets/icons/arrow-right-black.svg" />
                                                </button>
                                            </div>
                                        </button>
                                        <Collapsible open={this.state.isOpen[index]} transitionTime={500}>
                                            <div className="py-3 px-4" style={{ borderBottom: '1px solid #eee' }}>

                                                <div className="d-flex flex-wrap mt-2">
                                                    {prop.time.map((item, index) => {
                                                        return (
                                                            <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', 400: '12', 700: '3', lg: '3', xl: '2' }}>
                                                                <button className="w-90 p-2 br-10 flexcc mb-2 mrd-2 gray-filter" style={{ border: '1px solid #eee', backgroundColor: '#f8f8f8' }} onClick={() => { this.setTime(item) }}>
                                                                    <div className=" flex-column w-100">
                                                                        <div className="text-start">
                                                                            <div className="flexc">
                                                                                <img width={20} src="/assets/icons/booking/clock.svg" />
                                                                                <p className="font-size-14">{item.time} - {item.time}</p>
                                                                            </div>
                                                                            {/* <p className="font-size-12">Morning</p> */}

                                                                        </div>
                                                                        {/* <div className="flexc">
                                                                            <img width={20} src="/assets/icons/booking/dollar.svg" />
                                                                            <p className="font-size-14 text-semibold">{item.price}</p>
                                                                        </div> */}
                                                                    </div>
                                                                    <div className="br-20 px-2 py-2   flexcc " style={{ height: 24, width: 24, background: this.props.colors?.background }} >
                                                                        {/* <p className="white">Reserve</p> */}
                                                                        <img width={20} src="/assets/icons/arrow-right-white.svg" />

                                                                    </div>
                                                                </button>
                                                            </Responsive>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </Collapsible>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

